import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    emoji: '⚡',
    title: 'Libération de la Charge Mentale',
    desc: "Ouvrez le volume, suivez le flux et enseignez. Votre planification est déjà faite pour toute l'année."
  }, {
    emoji: '👑',
    title: 'Autorité et Confiance',
    desc: "Avec 60 séances structurées et validées pédagogiquement, vous arrivez en studio avec la posture d'un expert et le mot juste pour guider vos élèves."
  }, {
    emoji: '🌿',
    title: 'Progression Réelle des Élèves',
    desc: 'Des séquences validées qui respectent les principes de Joseph Pilates pour des résultats visibles et rapides.'
  }, {
    emoji: '😌',
    title: 'Zéro Stress de Transition',
    desc: 'Maîtrisez l\'art de connecter les exercices pour un "Flow" parfait qui impressionnera vos clients les plus exigeants.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-17">
            Ce qui va changer
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-18">
            Ce qui va changer dans votre{' '}
            <span className="italic text-pilates-rose" data-id="element-19">
              vie professionnelle
            </span>
          </h2>
          <p className="text-pilates-slate text-lg max-w-2xl mx-auto" data-id="element-20">
            Les bénéfices réels dès la première semaine :
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-21">
          {benefits.map((b, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 border border-pilates-sage/15 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-22">
              <div className="text-4xl mb-3" data-id="element-23">{b.emoji}</div>
              <h3 className="font-display font-semibold text-pilates-dark text-xl mb-2 leading-tight" data-id="element-24">
                {b.title}
              </h3>
              <p className="text-pilates-slate text-base leading-relaxed" data-id="element-25">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}